/**
 * ANB Gift Reggie App Optimizer
 * =============================
 * Purpose: Defer loading of Gift Reggie app scripts to improve TBT/LCP.
 * Strategy: Intercept script injection using MutationObserver, change type to prevent execution,
 *           then restore on user interaction.
 * 
 * Targets:
 * - Scripts containing "gift-reggie"
 * - Scripts containing "00fe746e" (App UUID)
 * - Scripts containing "moddapps"
 */

(function() {
  // Configuration
  const APP_PATTERNS = [
    'gift-reggie',
    '00fe746e', // App UUID
    'moddapps'
  ];
  
  const INTERACTION_EVENTS = ['scroll', 'mousemove', 'touchstart', 'click', 'keydown'];
  const IDLE_TIMEOUT = 5000; // Load after 5s if no interaction
  
  // State
  let observer;
  let deferredScripts = [];
  let deferredStyles = [];
  let isLoaded = false;
  
  // Helper: Check if node matches patterns
  function isTargetNode(node) {
    if (node.tagName !== 'SCRIPT' && node.tagName !== 'LINK') return false;
    
    const src = node.src || node.href || '';
    return APP_PATTERNS.some(pattern => src.includes(pattern));
  }
  
  // 1. The Interceptor (MutationObserver)
  function initObserver() {
    if (isLoaded) return;
    
    observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return; // Element nodes only
          
          if (isTargetNode(node)) {
            // Prevent execution/loading
            if (node.tagName === 'SCRIPT') {
              node.type = 'text/giftreggie-deferred';
              deferredScripts.push(node);
              // console.log('[ANB] Deferred Gift Reggie script:', node.src);
            } else if (node.tagName === 'LINK' && node.rel === 'stylesheet') {
              node.rel = 'stylesheet-deferred';
              node.media = 'print';
              deferredStyles.push(node);
              // console.log('[ANB] Deferred Gift Reggie style:', node.href);
            }
          }
        });
      });
    });
    
    // Observe document head for injected scripts
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    
    console.log('[ANB] Gift Reggie Optimizer initialized');
  }
  
  // 2. The Activator (Restore scripts)
  function loadApp() {
    if (isLoaded) return;
    isLoaded = true;
    
    // Stop observing
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    
    if (deferredScripts.length > 0 || deferredStyles.length > 0) {
      console.log(`[ANB] Loading Gift Reggie... (${deferredScripts.length} scripts, ${deferredStyles.length} styles)`);
    }
    
    // Restore Styles
    deferredStyles.forEach(link => {
      link.rel = 'stylesheet';
      link.media = 'all';
    });
    
    // Restore Scripts
    deferredScripts.forEach(script => {
      const newScript = document.createElement('script');
      Array.from(script.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.type = 'text/javascript';
      
      if (script.parentNode) {
        script.parentNode.replaceChild(newScript, script);
      } else {
        document.head.appendChild(newScript);
      }
    });
    
    // Cleanup listeners
    INTERACTION_EVENTS.forEach(event => {
      document.removeEventListener(event, loadApp);
    });
    
    // Dispatch event
    document.dispatchEvent(new CustomEvent('anb:giftreggie-loaded'));
  }
  
  // Initialize
  initObserver();
  
  // Set up triggers
  INTERACTION_EVENTS.forEach(event => {
    document.addEventListener(event, loadApp, { once: true, passive: true });
  });
  
  // Fallback timeout
  setTimeout(loadApp, IDLE_TIMEOUT);
  
})();

